import React, { useState, useEffect } from 'react';
import {
    Breadcrumbs,
    CssBaseline,
    Link,
    Paper
} from '@material-ui/core';
import ListSubheader from '@material-ui/core/ListSubheader';
import {
    Tabs,
    Table,
    Modal,
    Checkbox,
    message
} from 'antd';

import CreateProcedure from 'app/components/CreateProcedure/CreateProcedure';
import EditProcedure from 'app/components/EditProcedure/EditProcedure';
import NavMenu from 'components/NavMenu';
import ProcedureForm from 'app/components/ProcedureForm/ProcedureForm';
import TextEvents from 'app/components/TextEvents';
import EditCourseContainer from 'app/containers/EditCourseContainer';
import CourseTableContainer from 'app/containers/CourseTableContainer';
import { useStyles, styles } from './ScheduledProcedureScreenStyle';
import { fetchCourse, courseClear } from 'app/actions/CourseActions';
import { useDispatch, useSelector } from 'react-redux';
import ApiService from 'app/services/ApiService';

export default function ScheduleProcedure(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const {
        siteId
    } = useSelector(state => state.Auth)

    const { TabPane } = Tabs;
    const [filter, setFilter] = useState([]);
    const [activeKey, setTabBar] = useState('1');
    const tabs = { '1': 'Bandeja de Procedimientos / Material de capacitación', '2': 'Crear Procedimientos / Material de capacitación', '3': `${siteId === 'HUB' ? 'Editar' : 'Visualizar'} Procedimientos / Material de capacitación`, '4': 'Versionar Procedimientos / Material de capacitación' }
    const [idCourse, setIdCourse] = useState(null);
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [video, setLoader] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);

    
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows);
        },
        getCheckboxProps: record => ({
            disabled: record.url == null, // Column configuration not to be checked
        }),
    };

    useEffect(() => {
        return () => {
            dispatch(courseClear());
        }
    }, []);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });


    const [modalViewAnswers, setModalViewAnswers] = useState(false);
    const [viewAnswers, setViewAnswers] = useState(false);

    const updateViewAnswers = async () => {
        //putViewAnswers
        await ApiService.putViewAnswers(viewAnswers, idCourse)
            .then(response => {
            
                Modal.success({
                    title: `Visualizacion correctamente actualizada.`,
                    content: response.message,
                });
                setModalViewAnswers(false);
                dispatch(fetchCourse(formData));
            })
            .catch(error => {
                            
                Modal.error({
                    title: 'Ops, error de conexión',
                    content: 'Se perdió la conexión de red, intente más tarde.',
                });
            })
    }

    const currentViewAnswers = (visualize) => {
        setViewAnswers(visualize === null ? false : visualize);
        setModalViewAnswers(true);
    }

    return (
        <div className={classes.root}>
            <Modal
                title="Mostrar Respuestas al finalizar Evaluación?"
                closable
                destroyOnClose
                visible={modalViewAnswers}
                onOk={() => updateViewAnswers()}
                onCancel={() => setModalViewAnswers(false)}
            >
                <Checkbox checked={viewAnswers} onChange={(e) => setViewAnswers(e.target.checked)}>Mostrar respuestas al finalizar</Checkbox>
            </Modal>
            <NavMenu SelectedIndex={props.history.location.pathname} isAdmin={true} video={video} header='Procedimientos' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled >
                            Procedimiento
                        </Link>

                        <TextEvents
                            text={tabs[activeKey]}
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Tabs tabBarStyle={{ margin: 0 }} type="card" activeKey={activeKey} defaultActiveKey='1' className={classes.tabContainer} onChange={tab => setTabBar(tab)}>
                    <TabPane tab="Buscar" key="1" >
                        <Paper className={classes.paper} key='1'>
                            <ProcedureForm filter={filter} setFilter={setFilter} setTab={setTabBar} classes={classes} pagination={pagination} sorter={sorter} formData={formData} setFormData={setFormData}  selectedRows={selectedRows}/>
                            <div style={styles.baseVerticalMargin}>
                                <CourseTableContainer classes={classes} setTab={setTabBar} setIdCourse={setIdCourse} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination} formData={formData} currentViewAnswers={currentViewAnswers}>
                                    {(params) => {
                                        return (
                                            <div>
                                                <ListSubheader>
                                                    <Table
                                                        useFixedHeader={true}
                                                        loading={params.isLoading}
                                                        rowKey={item => String(item.idCourse)}
                                                        columns={params.cols}
                                                        dataSource={params.course}
                                                        onChange={params.handleTableChange}
                                                        pagination={pagination}
                                                        scroll={{ x: 'min-content', y: (height - 395) }}
                                                        size={"small"}
                                                    />
                                                </ListSubheader>
                                            </div>);
                                    }
                                    }
                                </CourseTableContainer>
                            </div>
                        </Paper>
                    </TabPane>
                    {activeKey === '2' ?
                        <TabPane tab='Nuevo' key='2' className={classes.tab}>
                            <Paper className={classes.tab} key="2">
                                <CreateProcedure setTab={setTabBar} formData={formData} setLoader={setLoader} />
                            </Paper>
                        </TabPane> : ''
                    }
                    {activeKey === '3' ?
                        <TabPane tab={siteId === 'HUB' ? 'Editar' : 'Visualizar'} key='3' className={classes.tab} >
                            <Paper className={classes.paper} key='3'>
                                <CourseTableContainer idCourse={idCourse} >
                                    {(params) => {
                                        const filterParam = params.course.find(function (element) {
                                            return element.idCourse === idCourse;
                                        });
                                        return (
                                            <div>
                                                <EditCourseContainer filterData={filterParam} >
                                                    {(editParams) => {
                                                        return (
                                                            <div>
                                                                <EditProcedure
                                                                    setLoader={setLoader}
                                                                    setTab={setTabBar}
                                                                    formData={formData}
                                                                    idCourse={idCourse}
                                                                    editParam={filterParam}
                                                                    courseCategory={editParams.coursesCategory}
                                                                    courseCategoryApprove={editParams.coursesCategoryApprove}
                                                                    isLoadingTest={editParams.loadingTest}
                                                                    isLoadingApprove={editParams.isLoadingApprove}
                                                                    isLoadingWorkCycle
                                                                    courseCategoryAsig={editParams.coursesCategoryAsig}
                                                                    courseCategoryApproveAsig={editParams.coursesCategoryApproveAsig}
                                                                    courseClientProcedure={editParams.coursesClientProcedure}
                                                                    courseClientProcedureAsig={editParams.coursesClientProcedureAsig}
                                                                    courseHomologousProcedure={editParams.coursesHomologousProcedure}
                                                                    courseHomologousProcedureAsig={editParams.coursesHomologousProcedureAsig}
                                                                    courseTest={editParams.coursesTest}
                                                                    courseTestAsig={editParams.coursesTestAsig}
                                                                    courseWorkCycle={editParams.coursesWorkCycle}
                                                                    courseWorkCycleAsig={editParams.coursesWorkCycleAsig} />
                                                            </div>
                                                        )
                                                    }
                                                    }
                                                </EditCourseContainer>
                                            </div>
                                        )
                                    }
                                    }
                                </CourseTableContainer>

                            </Paper>
                        </TabPane> : ''
                    }
                    {activeKey === '4' ?
                        <TabPane tab='Versionar' key='4' className={classes.tab}>
                            <Paper className={classes.paper} key='4'>
                                <CourseTableContainer idCourse={idCourse}>
                                    {(params) => {
                                        const filterParam = params.course.find(function (element) {
                                            return element.idCourse === idCourse;
                                        });
                                        return (
                                            <div>
                                                <EditCourseContainer filterData={filterParam}>
                                                    {(editParams) => {
                                                        return (
                                                            <div>
                                                                <EditProcedure
                                                                    isVersion={true}
                                                                    setLoader={setLoader}
                                                                    setTab={setTabBar} formData={formData} idCourse={idCourse} editParam={filterParam} courseCategory={editParams.coursesCategory}
                                                                    isLoadingTest={editParams.loadingTest}
                                                                    courseCategoryAsig={editParams.coursesCategoryAsig}
                                                                    courseCategoryApproveAsig={editParams.coursesCategoryApproveAsig}
                                                                    courseClientProcedure={editParams.coursesClientProcedure}
                                                                    courseClientProcedureAsig={editParams.coursesClientProcedureAsig}
                                                                    courseHomologousProcedure={editParams.coursesHomologousProcedure}
                                                                    courseHomologousProcedureAsig={editParams.coursesHomologousProcedureAsig}
                                                                    courseTest={editParams.coursesTest} courseTestAsig={editParams.coursesTestAsig} courseWorkCycle={editParams.coursesWorkCycle} courseWorkCycleAsig={editParams.coursesWorkCycleAsig} />
                                                            </div>
                                                        )
                                                    }
                                                    }
                                                </EditCourseContainer>
                                            </div>
                                        )
                                    }
                                    }
                                </CourseTableContainer>

                            </Paper>
                        </TabPane> : ''
                    }
                </Tabs>
            </div>
        </div>)
};